module.exports = __webpack_public_path__ + "img/svip_logo.0b6ab32d.png";